import { render } from "./ElementContent.vue?vue&type=template&id=a5a4ddae&scoped=true"
import script from "./ElementContent.vue?vue&type=script&lang=js"
export * from "./ElementContent.vue?vue&type=script&lang=js"

import "./ElementContent.vue?vue&type=style&index=0&id=a5a4ddae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a4ddae"]])

export default __exports__